/* AQUAWELLA homepage: desktop arrows for Shopify's built-in product gallery. */
(() => {
  function initGalleryArrows(scope = document) {
    scope.querySelectorAll('.aw4-buy-section media-gallery').forEach((gallery) => {
      if (gallery.dataset.aw4NavReady === 'true') return;
      const nav = gallery.querySelector('.aw4-gallery-nav');
      if (!nav) return;
      gallery.dataset.aw4NavReady = 'true';
      nav.addEventListener('click', (event) => {
        const button = event.target.closest('[data-aw4-gallery-step]');
        if (!button) return;
        const slides = [...gallery.querySelectorAll('[id^="Slider-Gallery-"] > [data-media-id]')];
        if (slides.length < 2) return;
        const current = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const index = current < 0 ? 0 : current;
        const next = slides[(index + Number(button.dataset.aw4GalleryStep) + slides.length) % slides.length];
        if (!next) return;
        gallery.setActiveMedia?.(next.dataset.mediaId, false);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGalleryArrows(), { once: true });
  } else {
    initGalleryArrows();
  }
  document.addEventListener('shopify:section:load', (event) => initGalleryArrows(event.target));
})();
